import React from "react";
import "./confirmDeleteModal.css";

const ConfirmDeleteModal = ({
	open,
	onConfirm,
	onCancel,
	loading
}) => {
	if (!open) return null;

	return (
		<div className="modal-backdrop">
			<div className="modal-glass">

				<h3 className="modal-title">
					Libelle entfernen?
				</h3>

				<p className="modal-text">

				</p>

				<div className="modal-actions">
					<button
						className="btn-secondary"
						onClick={onCancel}
						disabled={loading}
					>
						Abbrechen
					</button>

					<button
						className="btn-danger"
						onClick={onConfirm}
						disabled={loading}
					>
						{loading ? "Entfernen…" : "JA"}
					</button>
				</div>

			</div>
		</div>
	);
};

export default ConfirmDeleteModal;
